<div class="flex justify-end">
    <button mat-icon-button class="mt-2 mr-2 p-2 bg-gray-400" (click)="openInfo()"
        matTooltip="Click for information about this page.">
        <i class="fa-solid fa-info text-2xl text-gray-600"></i>
    </button>
</div>
<div class="flex flex-col items-center">
    <div id="map" class="rounded"></div>
    <form [formGroup]="locationForm" class="w-[75%] mt-2 flex justify-between items-center">
        <div class="flex space-x-2">
            <mat-form-field appearance="outline" class="w-52">
                <input matInput formControlName="latitude" placeholder="Latitude">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-52">
                <input matInput formControlName="longitude" placeholder="Longitude">
            </mat-form-field>
        </div>
        <div class="flex">
            <mat-form-field appearance="outline" class="w-96">
                <input matInput formControlName="location" placeholder="Location">
            </mat-form-field>
        </div>
    </form>
</div>
<div class="my-1 flex flex-col justify-center items-center">
    <div *ngIf="loading">
        <div class="mb-1 text-center">Loading Results...</div>
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
</div>
<div *ngIf="!loading && !soilDataAvailable">
    <mat-card class="w-full lg:w-1/3 items-start justify-start mx-4 mb-4">
        <mat-card-header class="justify-center text-xl" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            Saved Locations
        </mat-card-header>
        <mat-card-content>
            <div *ngIf="savedDataList && savedDataList.length > 0; else noData">
                <div *ngFor="let data of savedDataList" (click)="fillSoilDataForm(data)"
                    [ngClass]="{'selected-item': selectedSoilData === data}"
                    class="my-2 p-4 rounded hover:bg-gray-200 cursor-pointer">
                    <div class="w-full flex items-center gap-4">
                        <mat-icon matListItemIcon class="text-xl text-gray-600">place</mat-icon>
                        <div class="w-full">
                            <div class="text-sm sm:text-base font-medium">
                                <strong>Location:</strong> {{ data.location }}
                            </div>
                            <div class="text-sm sm:text-base text-gray-600">
                                <strong>Coordinates:</strong> {{ data.lat }}, {{ data.lon }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noData>
                <p>No saved data available.</p>
            </ng-template>
        </mat-card-content>
    </mat-card>
</div>
<div *ngIf="soilDataAvailable">
    <div class="w-full flex justify-around items-start space-x-2">
        <mat-card class="w-3/12">
            <mat-card-header class="justify-center text-xl" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                Saved Locations
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="savedDataList && savedDataList.length > 0; else noData">
                    <div *ngFor="let data of savedDataList" (click)="fillSoilDataForm(data)"
                        [ngClass]="{'selected-item': selectedSoilData === data}"
                        class="my-2 p-4 rounded hover:bg-gray-200 cursor-pointer">
                        <div class="w-full flex items-center gap-4">
                            <mat-icon matListItemIcon class="text-xl text-gray-600">place</mat-icon>
                            <div class="w-full">
                                <div class="text-sm sm:text-base font-medium">
                                    <strong>Location:</strong> {{ data.location }}
                                </div>
                                <div class="text-sm sm:text-base text-gray-600">
                                    <strong>Coordinates:</strong> {{ data.lat }}, {{ data.lon }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #noData>
                    <p>No saved data available.</p>
                </ng-template>
            </mat-card-content>
        </mat-card>
        <div class="w-9/12 flex flex-col">
            <mat-card class="w-full">
                <mat-card-header class="justify-center text-xl" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                    Selected Soil Data
                </mat-card-header>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 mb-8">
                    <div class="flex flex-col m-2">
                        <div class="block uppercase text-gray-600 text-sm font-bold my-3"
                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);">Climate (3-day forecast)</div>
                        <div class="grid grid-cols-2 space-x-2">
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block  text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                        Average Temperature (°C)
                                    </label>
                                    <input type="number" step="0.1"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        [(ngModel)]="temperature" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block  text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                        Total Precipitation (mm)
                                    </label>
                                    <input type="number" min="0" step="0.01"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        [(ngModel)]="precipitation" />
                                </div>
                            </div>
                        </div>
                        <div class="block uppercase text-gray-600 text-sm font-bold my-3"
                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);">Nutrients</div>
                        <div class="grid grid-cols-3 space-x-2">
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block  text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                        Nitrogen ({{nitroTarget}})
                                    </label>
                                    <input type="text" 
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        [(ngModel)]="nitro" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block  text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                        Phosphorus (g/kg)
                                    </label>
                                    <input type="number" min="0" step="0.01" placeholder="N/A"
                                        class="border-2 px-3 py-3 placeholder-gray-500 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        [(ngModel)]="phosphorus" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                        Potassium (g/kg)
                                    </label>
                                    <input type="number" min="0" step="0.01" placeholder="N/A"
                                        class="border-2 px-3 py-3 placeholder-gray-500 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        [(ngModel)]="potassium" />
                                </div>
                            </div>
                        </div>
                        <div class="block uppercase text-gray-600 text-sm font-bold my-3"
                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);">Farm Properties</div>
                        <div class="grid grid-cols-2 space-x-2">
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2 pt-1">Farming System</label>
                                    <select [(ngModel)]="farmingSystem"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                        <option *ngFor="let system of farmingSystems" [value]="system">{{ system
                                            }}</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block  text-gray-600 text-xs font-bold mb-2 warn">Crop Type <span class="text-red-600 text-sm">*</span></label>
                                    <select [(ngModel)]="cropType"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                        <option *ngFor="let type of cropTypes" [value]="type">{{ type
                                            }}</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                        Area of farm (ha)
                                    </label>
                                    <input type="number" min="0" step="0.01"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        [(ngModel)]="farmArea" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                        Yield (t/ha)
                                    </label>
                                    <input type="number" min="0" step="0.01" placeholder="N/A"
                                        class="border-2 px-3 py-3 placeholder-gray-500 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                        [(ngModel)]="yield" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col m-2">
                        <div class="block uppercase text-gray-600 text-sm font-bold my-3"
                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);">
                            Field Properties
                        </div>
                        <div class="grid grid-cols-2 space-x-2">
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Soil Texture</label>
                                    <input type="text" [(ngModel)]="soilTexture"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Ocs {{ocsTarget}}
                                    </label>
                                    <input type="number" min="0" step="0.01" [(ngModel)]="ocs"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                              <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Clay {{clayTarget}}
                                        (g/100g)</label>
                                    <input type="number" min="0" step="0.01" [(ngModel)]="clay"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Sand {{sandTarget}}
                                        (g/100g)</label>
                                    <input type="number" min="0" step="0.01" [(ngModel)]="sand"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Silt {{siltTarget}}
                                        (g/100g)</label>
                                    <input type="number" min="0" step="0.01" [(ngModel)]="silt"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Soil Organic Carbon
                                        ({{socTarget}})</label>
                                    <input type="number" min="0" step="0.01" [(ngModel)]="soc"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Organic Carbon Density
                                        ({{ocdTarget}})</label>
                                    <input type="number" min="0" step="0.01" [(ngModel)]="ocd"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">Bulk Density
                                        ({{bdodTarget}})</label>
                                    <input type="number" min="0" step="0.01" [(ngModel)]="bdod"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                            <div>
                                <div class="relative w-full mb-3">
                                    <label class="block text-gray-600 text-xs font-bold mb-2">pH</label>
                                    <input type="number" min="0" max="14" step="0.01" [(ngModel)]="ph"
                                        class="border-2 px-3 py-3 placeholder-gray-300 text-gray-600 bg-white rounded text-sm focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end items-end mx-4">
                    <button mat-raised-button id="saveButton" class="m-1"
                        (click)="openActionDialog()">
                        <i class="fa-solid fa-seedling"></i>
                        Select action for this Soil Data
                    </button>
                    <button *ngIf="showDelete" mat-raised-button color="warn" class="m-1"
                        (click)="deleteData(selectedSoilData._id)">
                        <i class="fa-solid fa-trash"></i>
                        Delete
                    </button>
                    <mat-checkbox [disabled]="isSaved || selectedSoilData !== null" [checked]="isCheckboxChecked()"
                        (change)="onCheckboxChange($event)">
                        Add to My Soil Data
                    </mat-checkbox>
                </div>

                <!-- ECONOMIC VALUES SECTION - NOW INSIDE THE CARD -->
                <div *ngIf="loading" class="my-4 flex flex-col justify-center items-center">
                    <div class="mb-1 text-center">Loading Economic Values...</div>
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>

                <div *ngIf="!loading && economicValuesAvailable" class="my-4">
                    <div class="text-center text-xl font-bold mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
                        Economic Values
</div>
            <div class="mt-8 flex flex-col items-center">
                <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                    [legend]="chartLegendFalse" [type]="'bar'" class="w-1/5 sm:w-2/3">
                </canvas>
            </div>
        
        <div class="my-4">
            <table mat-table [dataSource]="firstTableData" class="w-full">
                <ng-container matColumnDef="ncp">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex justify-center items-center">
                            NCP
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex justify-center items-center">
                            {{ element.ncp }}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="conventional">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex justify-center items-center">
                            Conventional farming
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex justify-center items-center">
                            {{ element.conventional }} 
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="organic">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex justify-center items-center">
                            Organic farming
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex justify-center items-center">
                            {{ element.organic }}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="economic">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex justify-center items-center">
                            Economic value
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex justify-center items-center">
                            {{ element.economic }} €
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="ncpColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: ncpColumns;"></tr>
            </table>
    </div>
        
        <!-- Second table commented out
        <div class="my-4">
            <table mat-table [dataSource]="secondTableData" class="w-full">
                <ng-container matColumnDef="measureName">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex justify-center items-center">
                            Measure name
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex justify-center items-center">
                            {{ element.measureName }}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="measure">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex justify-center items-center">
                            Measure
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex justify-center items-center">
                            {{ element.measure }}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex justify-center items-center">
                            Unit
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="flex justify-center items-center">
                            {{ element.unit }}
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="measureColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: measureColumns"></tr>
            </table>
        </div>
        -->
                </div>

            </mat-card>
        </div>
    </div>
</div>
<div *ngIf="!loading && noSoilData" class="my-4 flex justify-center">
    <mat-card class="w-2/3">
        <mat-card-header class="justify-center text-xl" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            SoilData not available for this location. Please try again.
        </mat-card-header>
    </mat-card>
</div>
<div *ngIf="!loading && predictionDataAvailable" class="my-4 flex justify-center">
    <mat-card class="w-2/3">
        <mat-card-header class="justify-center text-xl" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            Predictions
        </mat-card-header>
        <div class="mt-4 flex justify-center">
            <canvas baseChart [type]="'radar'" [datasets]="radarData" [labels]="radarChartLabels"
                [options]="radarChartOptions" [legend]="chartLegendTrue" class="w-1/5 sm:w-2/3">
            </canvas>
        </div>
    </mat-card>
</div>
<div *ngIf="!loading && benchmarkingDataAvailable" class="my-4 flex justify-center">
    <mat-card class="w-10/12">
        <mat-radio-group [(ngModel)]="selectedChart" class="flex justify-center gap-6">
            <mat-radio-button value="Bulk Density">Bulk Density</mat-radio-button>
            <mat-radio-button value="Soil Organic Carbon">Soil Organic Carbon</mat-radio-button>
            <mat-radio-button value="pH">pH</mat-radio-button>
        </mat-radio-group>
        <mat-card-header class="justify-center text-xl text-center my-6"
            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Benchmarking for {{selectedChart}}</mat-card-header>
        
        <div *ngIf="selectedChart==='Bulk Density'" class="flex justify-center">
            <canvas baseChart [type]="'line'" [datasets]="bulkData" [options]="chartOptions" [legend]="chartLegendTrue"
                class="w-full  mt-2">
            </canvas>
            <hr class="my-3" />
        </div>
        
        <div *ngIf="selectedChart==='pH'" class="flex justify-center">
            <canvas baseChart [type]="'line'" [datasets]="phData" [options]="chartOptions" [legend]="chartLegendTrue"
                class="w-full mt-2">
            </canvas>
            <hr class="my-3" />
        </div>
        
        <div *ngIf="selectedChart==='Soil Organic Carbon'" class="flex justify-center">
            <canvas baseChart [type]="'line'" [datasets]="socData" [options]="chartOptions" [legend]="chartLegendTrue"
                class="w-full mt-2">
            </canvas>
        </div>
    </mat-card>
</div>